/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import { z } from "zod/v4";

export const goodLuckCoreDTOsUserPrivacySettingsDtoSchema = z.object({
  showStats: z.optional(z.boolean()),
  showOnlineStatus: z.optional(z.boolean()),
  allowMessages: z.optional(z.boolean()),
  showInSearch: z.optional(z.boolean()),
});
